import { useState } from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { motion, AnimatePresence, useScroll, useSpring } from 'framer-motion'
import { Cursor } from '@/components/Cursor'
import { Loader } from '@/components/Loader'
import { Nav } from '@/components/Nav'
import { Footer } from '@/components/Footer'
import { ChatWidget } from '@/components/ChatWidget'
import { Hero } from '@/sections/Hero'
import { Marquee } from '@/sections/Marquee'
import { Services } from '@/sections/Services'
import { BA } from '@/sections/BA'
import { Process } from '@/sections/Process'
import { Stats } from '@/sections/Stats'
import { Testimonials } from '@/sections/Testimonials'
import { FAQ } from '@/sections/FAQ'
import { Contact } from '@/sections/Contact'

// Additional Pages
function ServicesPage() {
  return (
    <div style={{ paddingTop: 100 }}>
      <div style={{ maxWidth: 1400, margin: '0 auto', padding: '40px max(5vw, 24px)' }}>
        <h1 style={{ fontFamily: 'Bebas Neue', fontSize: 'var(--h1)', color: 'var(--white)' }}>
          All Services
        </h1>
      </div>
      <Services />
    </div>
  )
}

function AboutPage() {
  return (
    <div style={{ paddingTop: 100, minHeight: '100vh' }}>
      <div style={{ maxWidth: 1000, margin: '0 auto', padding: '40px max(5vw, 24px)' }}>
        <span style={{ fontFamily: 'DM Sans', fontSize: '0.8rem', color: 'var(--lime)', letterSpacing: '0.15em', textTransform: 'uppercase' }}>
          Our Story
        </span>
        <h1 style={{ fontFamily: 'Bebas Neue', fontSize: 'var(--h1)', color: 'var(--white)', marginTop: 12 }}>
          About Ashu
        </h1>
        <p style={{ fontFamily: 'DM Sans', fontSize: '1.1rem', color: 'var(--white-60)', lineHeight: 1.8, marginTop: 32 }}>
          Founded in Addis Ababa, Ashu Cleaning Service has been transforming homes and offices across Ethiopia's capital. 
          We combine traditional Ethiopian hospitality with modern cleaning techniques to deliver exceptional results.
        </p>
        <div style={{ marginTop: 48, display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 32 }}>
          {[
            { title: 'Our Mission', text: 'To provide world-class cleaning services that exceed expectations while creating jobs for local communities.' },
            { title: 'Our Values', text: 'Integrity, Excellence, and Community. We believe in honest work and fair prices.' },
            { title: 'Our Promise', text: '100% satisfaction guaranteed. If you are not happy, we return and re-clean for free.' }
          ].map((item) => (
            <div key={item.title} style={{ padding: 32, background: 'var(--surface)', borderRadius: 16 }}>
              <h3 style={{ fontFamily: 'DM Sans', fontWeight: 700, color: 'var(--lime)', marginBottom: 12 }}>{item.title}</h3>
              <p style={{ fontFamily: 'DM Sans', color: 'var(--white-60)', lineHeight: 1.6 }}>{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

function GalleryPage() {
  const images = [
    'https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=400&q=80',
    'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=400&q=80',
    'https://images.unsplash.com/photo-1556911220-e15b29be8c8f?w=400&q=80',
    'https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?w=400&q=80',
    'https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=400&q=80',
    'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=400&q=80'
  ]
  return (
    <div style={{ paddingTop: 100, minHeight: '100vh' }}>
      <div style={{ maxWidth: 1400, margin: '0 auto', padding: '40px max(5vw, 24px)' }}>
        <span style={{ fontFamily: 'DM Sans', fontSize: '0.8rem', color: 'var(--lime)', letterSpacing: '0.15em', textTransform: 'uppercase' }}>
          Our Work · ስራችን
        </span>
        <h1 style={{ fontFamily: 'Bebas Neue', fontSize: 'var(--h1)', color: 'var(--white)', marginTop: 12 }}>
          Gallery
        </h1>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16, marginTop: 48 }}>
          {images.map((img, i) => (
            <motion.div
              key={i}
              whileHover={{ scale: 1.02 }}
              style={{
                aspectRatio: '1',
                borderRadius: 12,
                overflow: 'hidden',
                backgroundImage: `url(${img})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center'
              }}
            />
          ))}
        </div>
      </div>
    </div>
  )
}

function BookPage() {
  return (
    <div style={{ paddingTop: 100, minHeight: '100vh' }}>
      <Contact />
    </div>
  )
}

function AdminPage() {
  const [password, setPassword] = useState('')
  const [isAuthenticated, setIsAuthenticated] = useState(false)

  if (!isAuthenticated) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ padding: 40, background: 'var(--surface)', borderRadius: 20, textAlign: 'center' }}>
          <h2 style={{ fontFamily: 'Bebas Neue', fontSize: '2rem', color: 'var(--white)', marginBottom: 24 }}>
            Admin Access
          </h2>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter password"
            style={{
              padding: '12px 16px',
              background: 'var(--elevated)',
              border: '1px solid rgba(255,255,255,0.1)',
              borderRadius: 8,
              color: 'var(--white)',
              fontFamily: 'DM Sans',
              marginBottom: 16,
              display: 'block',
              width: 250
            }}
          />
          <button
            onClick={() => password === 'admin2024' && setIsAuthenticated(true)}
            style={{
              padding: '12px 24px',
              background: 'var(--lime)',
              border: 'none',
              borderRadius: 8,
              color: 'var(--black)',
              fontFamily: 'DM Sans',
              fontWeight: 700,
              cursor: 'pointer'
            }}
          >
            Login
          </button>
        </div>
      </div>
    )
  }

  return (
    <div style={{ paddingTop: 100, minHeight: '100vh' }}>
      <div style={{ maxWidth: 1400, margin: '0 auto', padding: '40px max(5vw, 24px)' }}>
        <h1 style={{ fontFamily: 'Bebas Neue', fontSize: 'var(--h1)', color: 'var(--white)' }}>
          Admin Dashboard
        </h1>
        <p style={{ fontFamily: 'DM Sans', color: 'var(--white-60)', marginTop: 24 }}>
          Welcome to the admin dashboard. Manage bookings, view analytics, and more.
        </p>
      </div>
    </div>
  )
}

function HomePage() {
  return (
    <>
      <Hero />
      <Marquee />
      <Services />
      <BA />
      <Process />
      <Stats />
      <Testimonials />
      <FAQ />
      <Contact />
    </>
  )
}

// Scroll progress bar
function ScrollProgress() {
  const { scrollYProgress } = useScroll()
  const scaleX = useSpring(scrollYProgress, { stiffness: 100, damping: 30, restDelta: 0.001 })

  return (
    <motion.div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        height: 2,
        background: 'linear-gradient(90deg, var(--lime), var(--red))',
        transformOrigin: '0% 0%',
        scaleX,
        zIndex: 9999
      }}
    />
  )
}

// Page transitions wrapper
function AnimatedRoutes() {
  return (
    <AnimatePresence mode="wait">
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/gallery" element={<GalleryPage />} />
        <Route path="/contact" element={<BookPage />} />
        <Route path="/book" element={<BookPage />} />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
    </AnimatePresence>
  )
}

function AppContent() {
  const [loading, setLoading] = useState(true)

  return (
    <>
      <Loader onComplete={() => setLoading(false)} />
      {!loading && (
        <>
          <Cursor />
          <ScrollProgress />
          <Nav />
          <main>
            <AnimatedRoutes />
          </main>
          <Footer />
          <ChatWidget />
        </>
      )}
    </>
  )
}

export default function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  )
}
